// @ts-strict-ignore
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UserModel } from '@user/model/user.model';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { LocaleLanguage } from '@user/components/language/locale-language';
import { Subscription } from 'rxjs/internal/Subscription';
import { ProjectNavigationPresenter } from '@project-navigation/project-navigation.presenter';
import { ImportChoiceDialogComponent } from './import-choice-dialog/import-choice-dialog.component';
import { ConfigurationCreationWizardPresenter } from '@configuration/wizard/presenter/configuration-creation-wizard.presenter';
import { WindowService } from '@shared/window/window.service';
import { ProjectModelService } from '../../../service/project-model.service';
import { TemplateModel } from '@configuration/wizard/models/assistants/template-model';
import { WizardStartupService } from '@configurator/wizard-start/wizard-startup.service';

@Component({
  standalone: false,
  templateUrl: 'open-project.component.html',
  selector: "app-open-project",
  styleUrls: [ 'open-project.component.scss' ],
  providers: [ TemplateModel ],
})
export class OpenProjectComponent implements OnInit, OnDestroy {

  public currentLanguage: string;
  public isLoggedIn: boolean = false;
  public userName: string = '';

  private subscriptions: Subscription;

  constructor(
    private readonly userModel: UserModel,
    private readonly localeResourceManager: LocaleResourceManager,
    private readonly projectNavigationPresenter: ProjectNavigationPresenter,
    private readonly configurationCreationWizardPresenter: ConfigurationCreationWizardPresenter,
    private readonly windowService: WindowService,
    private readonly projectModelService: ProjectModelService,
    private readonly templateModel: TemplateModel,
    private readonly wizardStartupService: WizardStartupService,
  ) {
  }

  public ngOnInit(): void {
    this.subscriptions = new Subscription();
    this.subscriptions.add(this.localeResourceManager.localeChanged$.subscribe((lang: LocaleLanguage) => this.onLocaleChange(lang)));
    void this.projectModelService.clearCurrentProject().then(() => {
    this.openPendingWizardIfAny();
    });
  }

  /** starts the wizard requested via a `/wizard/:wizardName` (see rememberWizardNameGuard). */
  private openPendingWizardIfAny(): void {
    const wizardName = sessionStorage.getItem('pendingWizardName');
    sessionStorage.removeItem('pendingWizardName');
    if (!wizardName) {
      return;
    }

    const wizardModel = this.wizardStartupService.getWizardByNameIfAllowed(wizardName);
    if (!wizardModel) {
      return;
    }

    this.configurationCreationWizardPresenter.openWizard(true, wizardModel);
  }

  public openImportChoiceDialog() {
    this.windowService.showModalFullscreen(ImportChoiceDialogComponent, {isLoggedIn: this.isLoggedIn});
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.subscriptions = undefined;
  }


  public isMyProjectsEnabled(): boolean {
    return this.userModel.isUserLoggedIn;
  }

  getGreetingName(): string | null {
    const profile = this.userModel.userProfile;
    this.isLoggedIn = profile && profile.isRegisteredUserAccount();

    if(!this.isLoggedIn) return null

    let greetingName = `${profile.user?.name ?? ""} ${profile.user?.surname ?? ""}`.trim();
    if (greetingName == "") {
      greetingName = profile.user.login;
    }

    return greetingName;
  }

  public openNewConfigurationDialog(): void {
    this.configurationCreationWizardPresenter.openWizard(true);
  }

  public openCreateFromTemplateWizard(): void {
    this.configurationCreationWizardPresenter.openWizard(true, this.templateModel);
  }

  public async openProject(): Promise<void> {
    await this.projectNavigationPresenter.openLoadProjectDialog({
      navigateToConfigurator: true,
      newProjectCreation: true,
      fromDashBoard: true
    });
  }

  private onLocaleChange(language: LocaleLanguage): void {
    this.currentLanguage = language.langKey.substring(0, 2).toUpperCase();
  }
}
